<template>
  <v-dialog
    :value="value"
    max-width="560"
    persistent
    @input="$emit('input', $event)"
  >
    <div class="rv">
      <h3>Вернуть версию от {{ date(snapshot && snapshot.takenAt) }}?</h3>
      <p class="rv-sub">
        Зоны филиала станут такими, какими были до этого изменения. Всё, что менялось после, тоже отменится.
      </p>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class="rv-progress"
      />
      <template v-else-if="plan">
        <div class="rv-counts">
          <div
            v-for="c in counts"
            :key="c.key"
            class="rv-count"
            :class="c.key"
          >
            <b>{{ c.value }}</b> {{ c.label }}
          </div>
        </div>
        <div v-if="empty" class="rv-empty">
          Текущие зоны уже совпадают с этой версией.
        </div>
        <v-expansion-panels
          v-else
          flat
          accordion
          class="rv-details rv-list"
        >
          <v-expansion-panel v-if="plan.update.length">
            <v-expansion-panel-header>Изменится ({{ plan.update.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="u in plan.update" :key="u.id" class="rv-line">
                {{ updateLine(u) }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="plan.recreate.length">
            <v-expansion-panel-header>Восстановится ({{ plan.recreate.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="r in plan.recreate" :key="r.id" class="rv-line">
                {{ recreateLine(r) }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="plan.delete.length">
            <v-expansion-panel-header>Удалится ({{ plan.delete.length }})</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="d in plan.delete" :key="d.id" class="rv-line">
                «{{ d.name }}»
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="tiers.length">
            <v-expansion-panel-header>Тарифы</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(t, i) in tiers" :key="i" class="rv-line">
                {{ t }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div
          v-for="(w, i) in plan.warnings"
          :key="'w' + i"
          class="rv-warn"
          :class="w.code"
        >
          {{ warningText(w) }}
        </div>
      </template>
      <div v-if="error" class="rv-error">
        {{ error }}
      </div>
      <div class="rv-actions">
        <button
          type="button"
          class="btn-cancel"
          :disabled="saving"
          @click="$emit('input', false)"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn-apply"
          :disabled="loading || saving || !plan || empty"
          @click="$emit('confirm')"
        >
          {{ saving ? 'Возвращаем…' : 'Вернуть' }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { historyDate } from './zonesHistoryText'
  import { planCounts, updateLine, recreateLine, tierLines, warningText, isPlanEmpty } from './restorePlanText'

  /** Подтверждение отката филиала к снимку: план с бэка, предупреждения, кнопка «Вернуть». */
  export default {
    name: 'RestoreVersionDialog',
    props: {
      value: { type: Boolean, default: false },
      snapshot: { type: Object, default: null },
      plan: { type: Object, default: null },
      loading: { type: Boolean, default: false },
      saving: { type: Boolean, default: false },
      error: { type: String, default: '' },
    },
    computed: {
      counts () {
        return this.plan ? planCounts(this.plan) : []
      },
      empty () {
        return this.plan ? isPlanEmpty(this.plan) : true
      },
      tiers () {
        return this.plan ? tierLines(this.plan.tiers) : []
      },
    },
    methods: {
      date (s) {
        return historyDate(s)
      },
      updateLine,
      recreateLine,
      warningText,
    },
  }
</script>

<style scoped src="./restore-dialog.css"></style>
